<template>
    <div class="body-content">
        <div class="content-layout">
            <div class="left-section">
                <discuss-category @areaChange="handleAreaChange"></discuss-category>
            </div>
            <div class="center-section">
                <div class="list__header">
                    <div class="list__nav">
                        <div class="nav-items">
                            <div class="list__nav-item" :class="{ 'list__nav-item--active': item.id === navId }"
                                v-for="item in navs" :key="item.title" @click="changeNavType(item)">{{ item.title }}
                            </div>
                        </div>
                        <div class="publish-link">
                            <button class="publish">
                                <span @click="toPublish()">写文章</span> <el-divider direction="vertical" />
                                <span style="padding: 4px;" v-if="!isShowTempArticle" class="el-icon-caret-bottom" @click.stop="isShowTempArticle = true" />
                                <span style="padding: 4px;" v-else class="el-icon-caret-top" @click.stop="isShowTempArticle = false" />
                            </button>
                            <div class="temp" v-if="isShowTempArticle">
                                <div class="temp-item" @click="goToDraft()">
                                    <div><span class="el-icon-document-copy" /></div>
                                    <div>草稿箱</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="loading">
                    <el-skeleton :rows="7" animated>
                        <template slot="template">
                            <div v-for="i in 7" :key="i" class="article-item skeleton-item">
                                <el-skeleton-item variant="p" style="width: 100%;height: 40px;"/>
                            </div>
                        </template>
                    </el-skeleton>
                </div>
                <artic-list :list="articleList" id="articleListDom" v-else @autoGetArticle="autoGetArticle()"/>
                <el-empty v-if="!loading && articleList.length === 0" style="height: 590px;" description="暂无数据" />
                <div v-if="!loading && !hasMoreData && articleList.length > 0" class="no-more-data">已加载全部数据</div>
            </div>
            <div class="right-section">
                <!-- <user-data class="user-data"></user-data> -->
                <tool-box class="tool-box"></tool-box>
            </div>
        </div>
        <el-backtop>
            <div class="back-top">
                <div class="el-icon-arrow-up"></div>
            </div>
        </el-backtop>
    </div>
</template>
<script>
import discussCategory from '@/components/business/discuss/discussCategory.vue';
import userData from '@/components/business/discuss/userData.vue';
import toolBox from '@/components/business/discuss/toolBox.vue';
import news from '@/components/business/discuss/news.vue';
import {getArticleList} from '@/api';
import {throttle} from 'lodash'

export default {
    name: "CommunityHomePage",
    data() {
        return {
            isShowTempArticle: false,
            navs: [
                {
                    id: 1,
                    title: '最新',
                    type: 1
                },
                {
                    id: 2,
                    title: '最热',
                    type: 2
                },
                // {
                //     id: 3,
                //     title: '关注',
                //     type: 3,
                // }
            ],
            navId: 1,
            navTypes: [],
            articleList: [],
            pageNum: 1,
            pageSize: 20,
            areaId: localStorage.getItem('selectedAreaId'),
            loading: true,
            keyword: '',
            hasMoreData: true // 是否还有更多数据
        }
    },
    components: {
        'discuss-category': discussCategory,
        'user-data': userData,
        'tool-box': toolBox,
        'news': news
    },
    methods: {
        changeNavType(item) {
            if (this.navId !== item.id) {
                this.navId = item.id
            }
            this.pageNum = 1
            this.articleList = []
            this.loading = true;
            this.hasMoreData = true; // 重置hasMoreData状态
            this.getArticle()
        },
        toPublish(hash) {
            this.$router.push({
                name: 'CommunityPublishArticlePage',
                params: {
                    id: 'new'
                },
                query: {
                    hash: hash
                }
            })
        },
        handleAreaChange(areaId) {
            this.pageNum = 1;
            this.areaId = areaId;
            this.loading = true;
            this.articleList = [];
            this.hasMoreData = true; // 重置hasMoreData状态
            this.getArticle();
        },
        handleSearch(data) {
            this.keyword = data.keyword;
            this.pageNum = 1;
            this.loading = true;
            this.articleList = [];
            this.hasMoreData = true; // 重置hasMoreData状态
            this.getArticle();
        },
        handleInput(value){
            this.keyword = value;
        },
        getArticle() {
            let params = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                areaId: this.areaId,
                searchValue: this.keyword.trim(),
                params: {}
            }
            // 处理对应的业务逻辑
            if (this.navId === 1) { // 最新
                params.params.sort = 'create_time'
                params.params.order = 'desc'
            } else if (this.navId === 2) {
                params.params.sort = 'like_count' // 最热
                params.params.order = 'desc'
            } else if (this.navId === 3) { // 我的关注

            }
            getArticleList(params).then(response => {
                // 追加新文章到列表
                this.articleList = this.articleList.concat(response.rows);
                
                // 判断是否还有更多数据
                // 1. 如果返回的数据少于请求的每页数量，说明没有更多数据了
                // 2. 如果当前总数已经等于或超过了total，说明没有更多数据了
                if (response.rows.length < this.pageSize || 
                    this.articleList.length >= response.total) {
                    this.hasMoreData = false;
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
                if (this.pageNum > 1) {
                    this.pageNum -= 1; // 加载失败时恢复页码
                }
            });
        },
        // 文章列表滚动事件
        autoGetArticle() {
            // 如果没有更多数据或者正在加载中，不再触发加载
            if (!this.hasMoreData || this.loading) {
                return;
            }
            this.pageNum += 1;
            this.getArticle();
        },
        // 跳转草稿箱界面
        goToDraft() {
            this.$router.push('/community/draft');
        },
        handleScroll: throttle(async function () {
            // 使用普通函数，this 会指向组件实例
            const scrollTop = window.scrollY;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            const distanceToBottom = documentHeight - (scrollTop + windowHeight);
            
            // 当距离底部50px时，且有更多数据可加载时，加载更多数据
            if (distanceToBottom <= 50 && this.hasMoreData && !this.loading) {
                await this.autoGetArticle();
            }
        }, 300)
    },
    mounted() {
        this.getArticle()
        window.addEventListener('scroll', this.handleScroll)
        this.$eventBus.$on('search', this.handleSearch);
        this.$eventBus.$on('input', this.handleInput);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
        this.$eventBus.$off('search');
        this.$eventBus.$off('input');
    }
}

</script>
<style lang="scss" scoped>
.body-content {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    padding: 0 20px;
    box-sizing: border-box;

    .content-layout {
        display: flex;
        flex-wrap: wrap;
        gap: 0; /* 移除默认间距，使用明确的 margin 控制 */
        position: relative; /* 为内部元素提供定位上下文 */
    }

    .left-section {
        width: 148px;
        position: relative;
        margin-right: 0; /* 确保没有额外的右侧间距 */
        
        /* 确保 discuss-category 组件在其父容器中正确显示 */
        ::v-deep .nav-list {
            position: fixed;
            max-height: calc(100vh - 100px);
            overflow-y: auto;
        }
    }

    .center-section {
        flex: 1;
        min-width: 0;
        margin-left: 20px;
        margin-right: 320px;/* 与右侧区域保持一致的间距 */
        background: #fff;
        border-radius: 10px;
        padding: 20px;
        box-sizing: border-box;
    }

    .right-section {
        width: 300px;
        max-height: calc(100vh - 100px);
        position: fixed;
        top: 80px;
        // right: 160px;
        right: 0px;
        background-color: $background-color;
        border-radius: 10px;
        transition: all .2s;
        overflow-y: auto;

        .user-data {
            height: 60%;
        }

        /* 隐藏滚动条但保持滚动功能 */
        &::-webkit-scrollbar {
            width: 0;
            display: none;
        }

        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
    }

    .list__header {
        border-bottom: 1px solid $color-third;
    }

    .list__nav {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .nav-items {
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        .publish-link {
            position: relative;

            .publish {
                font-size: $font-size-Level6;
                width: 110px;
                height: 30px;
                background-color: $color-primary;
                border-radius: 5px;
                cursor: pointer;
                color: $font-color-secondary;
                transition: background-color 0.3s ease;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 20px;
                &:hover {
                    background-color: darken($color-primary, 5%);
                }
            }

            .temp {
                position: absolute;
                left: 0;
                top: 35px;
                z-index: 11;
                cursor: pointer;
                .temp-item {
                    width: 110px;
                    background-color: #FFFFFF;
                    color: #1a1a1a;
                    cursor: pointer;
                    font-size: 14px;
                    border-radius: 5px;
                    box-shadow: 0 0 6px #b0b0b0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    align-content: center;
                    flex-wrap: wrap;
                    transition: background-color 0.3s ease;
                    padding: 10px 0px;
                    div {
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        span {
                            margin-bottom: 5px;
                            font-size: 24px;
                        }
                    }
                }
            }
        }
        .list__nav-item {
            height: 50px;
            display: inline-block;
            font-size: $font-size-Level5;
            color: $font-color-primary;
            cursor: pointer;
            padding: 0 23px;
            position: relative;
            line-height: 50px;

            &:hover,
            &.list__nav-item--active {
                color: $color-primary;
            }

            &.list__nav-item--active::after {
                content: '';
                position: absolute;
                bottom: -3px;
                right: 0;
                width: 34px;
                height: 8px;
                background: $color-primary;
                left: 30%;
                transform: scaleY(.5);
            }
        }
    }
    
    .skeleton-item {
        background-color: #fff !important;
        padding: 20px 25px;
    }

    .back-top {
        width: 100%;
        height: 100%;
        background-color: #f2f5f6;
        box-shadow: 0 0 6px rgba(0, 0, 0, .12);
        border-radius: 6px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        flex-wrap: wrap;

        div {
            width: 100%;
            text-align: center;
            color: $color-primary;
        }
    }
    
    .no-more-data {
        text-align: center;
        color: #999;
        font-size: 14px;
        padding: 15px 0;
        margin-top: 10px;
        border-top: 1px solid #f0f0f0;
    }

    /* 超大屏幕 */
    @media screen and (min-width: 1801px) {
        .right-section {
            right: calc((100vw - 1200px) / 2 + 20px); /* 默认位置 */
        }
    }

    /* 大屏幕 */
    @media screen and (max-width: 1800px) and (min-width: 1401px) {
        .right-section {
            right: 160px;
        }
        
        .center-section {
            margin-right: 320px; /* 与右侧区域宽度保持一致 */
        }
    }

    /* 中等屏幕 */
    @media screen and (max-width: 1400px) and (min-width: 1101px) {
        .right-section {
            right: 60px;
        }
        
        .center-section {
            margin-right: 320px; /* 与右侧区域宽度保持一致 */
        }
    }
    
    /* 小屏幕 */
    @media screen and (max-width: 1100px) and (min-width: 993px) {
        .center-section {
            margin-right: 270px; /* 与右侧区域宽度保持一致 */
        }
        
        .right-section {
            width: 250px; /* 减小右侧区域宽度 */
            right: 60px;
        }
    }

    @media screen and (max-width: 992px) {
        .left-section {
            display: none; /* 在窄屏幕上隐藏左侧分类 */
        }
        
        .center-section {
            width: 100%;
            margin-left: 0;
            margin-right: 0;
        }
        
        .right-section {
            display: none; /* 在窄屏幕上隐藏右侧工具栏 */
        }
    }
}
</style>